<template>
  <div id="element">
    <b-container>
      <b-card-group deck class="justify-content-center card-deck-local">
        <b-card title="" tag="article" style="max-width: 20rem;" class="mb-2">
          <b-card-img
            class="mb-2"
            src="./../assets/bp2.png"
            alt="Image"
            top
            width="100%"
          ></b-card-img>
          <!-- height="10%" -->
          <b-card-title tabindex="0">
            {{ $t("card3Title") }}
          </b-card-title>
          <b-card-text tabindex="0" class="text-justify">
            {{ $t("card3Text") }}
          </b-card-text>
        </b-card>
        <b-card
          title=""
          tag="article"
          style="max-width: 20rem;"
          class="mb-2 align-middle"
        >
          <div v-if="isRussian">
            <iframe
              class="mr-0 ml-0 mt-2 mb-2"
              width="100%"
              height="auto"
              src="https://www.youtube.com/embed/uibjtfZruPo"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              title="BuzzPoint на Youtube"
            ></iframe>
          </div>
          <div v-if="!isRussian">
            <iframe
              width="100%"
              height="auto"
              src="https://www.youtube.com/embed/G0bFsK6RCBs"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              title="BuzzPoint on Youtube"
            ></iframe>
          </div>
          <b-card-title tabindex="0">
            {{ $t("card1Title") }}
          </b-card-title>
          <b-card-text tabindex="0" class="text-justify">
            {{ $t("card1Text") }}
          </b-card-text>
        </b-card>
        <b-card title="" tag="article" style="max-width: 20rem;" class="mb-2">
          <b-card-img
            class="mb-2"
            src="./../assets/bp1.png"
            alt="Image"
            top
            width="100%"
          ></b-card-img>
          <!-- height="200px" -->
          <b-card-title tabindex="0">
            {{ $t("card2Title") }}
          </b-card-title>
          <b-card-text tabindex="0" class="text-justify">
            {{ $t("card2Text") }}
          </b-card-text>
        </b-card>
      </b-card-group>
    </b-container>
  </div>
</template>

<script>
export default {
  computed: {
    isRussian() {
      if (this.$i18n.locale === "ru") return true;
      else return false;
    }
  }
};
</script>

<style scoped>
.v-card__title {
  font-size: 1.4rem;
}

.card-deck-local {
  align-items: center;
}

@media screen and (min-width: 667px) {
  .card-deck-local {
    align-items: start;
  }
}
/* .card-body {
  max-height: 375px;
  overflow: hidden;
}
.card-body img {
  float: top;
  margin-top: -100%;
} */
</style>
